import type { MapRef } from 'react-map-gl/mapbox';
import type { SearchParams } from '@/server/searchParams.ts';
import type { CardProps } from '@/app/components/search/components/Card/types.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import type { Localization } from '../../../../../common/Localization';
import { type CuriosityParams, RouteType } from '../../../../../Curiosity';
import type { ClickParams } from '../../../../../Curiosity/Analytics/utils';
import clickEvent from '../../../../../Curiosity/clickEvent';
import getSearchParams from '../../../../../common/getSearchParams';
import type { DealCard } from '../../../../../utils/buildDealCards/dealCardTypes';

type CTACallBackProps = {
  e?:
    | React.MouseEvent<HTMLAnchorElement, MouseEvent>
    | React.MouseEvent<HTMLDivElement, MouseEvent>
    | React.MouseEvent<HTMLButtonElement>;
  dealCard?: DealCard;
  payload?: ClickParams;
};
export type PopupCardProps = {
  cardWidth: string;
  isDot: boolean;
  coordinates: {
    lat: number;
    lng: number;
  };
  mapProps: CardProps;
  isWaiting: boolean;
  isLoading: boolean;
  searchParams: SearchParams;
};

export const calculateCardWidth = (isMobile: boolean) => {
  if (isMobile) return `${window.innerWidth - 32}px`;
  return '320px';
};

type HandlePopupCardHotelChosen = (chosenHotelId: string, dealCard: DealCard | undefined) => void;

type GetPopupCardProps = {
  dealCard?: DealCard;
  isDot: boolean;
  commonData: CommonData;
  localization: Localization;
  curiosityParams: CuriosityParams;
  mapRef: React.RefObject<MapRef | null>;
  isMobile: boolean;
  handlePopupCardHotelChosen: HandlePopupCardHotelChosen;
  isWaiting: boolean;
  isLoading: boolean;
};
const getPopupCardProps = ({
  dealCard,
  isDot,
  commonData,
  localization,
  curiosityParams,
  mapRef,
  isMobile,
  handlePopupCardHotelChosen,
  isWaiting,
  isLoading,
}: GetPopupCardProps): PopupCardProps => {
  const cardWidth = calculateCardWidth(isMobile);
  const coordinates = isMobile
    ? {
        lat: mapRef.current?.getCenter().lat || 0,
        lng: mapRef.current?.getCenter().lng || 0,
      }
    : {
        lat: dealCard?.product?.accommodation?.latitude || 0,
        lng: dealCard?.product?.accommodation?.longitude || 0,
      };
  const searchParams = getSearchParams();

  const dealCardCtaCallBack = ({ e, dealCard: dealCardCta, payload }: CTACallBackProps) => {
    if (payload) {
      clickEvent({
        clickParams: payload,
        routeType: RouteType.OSMAP,
        commonData,
        localization,
        curiosityParams,
      });
    }

    if (e) {
      handlePopupCardHotelChosen(`${dealCard?.product?.accommodation?.hotelId || ''}`, dealCardCta);
    }
  };

  return {
    cardWidth,
    isDot,
    coordinates,
    mapProps: {
      dealCard: dealCard || undefined,
      isOverlay: true,
      dealCardCtaCallBack,
    },
    isWaiting,
    isLoading,
    searchParams,
  };
};

export default getPopupCardProps;
